
const Project = (title,image,link) => {
    return (
      <div id='HWNIDCONTAINER' className="flex flex-col items-center justify-center mt-10 max-w-5xl w-full mx-auto">
            <h2 className="text-4xl font-bold my-5 gradient-text text-center xl:text-center w-full">{title}</h2>
            <a className="block w-full" href={link}>
              <img
                src={image}
                alt={title}
                loading="lazy"
                className="w-full max-w-[800px] h-auto object-contain rounded-lg shadow-md mx-auto snap-center"
              />
            </a>
          </div>
    );
  }
  export default Project;